/*
 * Contacts activity strip (Customers section, 2026-10-09): six numbers for the period picked in the top bar,
 * from GET /v1/activity/contacts/dashboard/{range}?comparison= (the endpoint the old Contacts page used).
 * A change is shown only when both periods are big enough to mean something (no "+400%" on 3 people).
 */
import React from "react";
import ServiceFactory from "../../service";
import { Ribbon } from "../../components/analytics-kit";
import { num, comparisonQs, deltaVsFullPrior, rangeLabelFor, RANGES } from "../sales/territory-common";
import { getGlobalRange, getGlobalComp, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
const MIN = 10; // both periods need at least this many before a change is shown

// The kit's delta shape ({dir, pct}), or null (no chip) when either period is too small to compare.
function change(cur, prev, range) {
  if ((Number(cur) || 0) < MIN || (Number(prev) || 0) < MIN) return null;
  const d = deltaVsFullPrior(cur, prev, range); // this endpoint compares with the whole previous period
  return d && isFinite(d.pct) ? {
    dir: d.dir,
    pct: d.pct
  } : null;
}
export default class ContactsStrip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      range: getGlobalRange(),
      data: undefined
    };
  }
  componentDidMount() {
    this._alive = true;
    this.load();
    this._tok = subscribePeriod(({
      range
    }) => {
      if (this._alive && range && range !== this.state.range) this.setState({
        range,
        data: undefined
      }, () => this.load());
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._tok);
  }
  async load() {
    const range = this.state.range;
    try {
      const Service = ServiceFactory.getType(`/contacts/dashboard/${range}${comparisonQs(range, true, getGlobalComp("prev_period"))}`);
      const d = await new Service().getAsync();
      if (this._alive && range === this.state.range) this.setState({
        data: d || null
      });
    } catch (e) {
      if (this._alive) this.setState({
        data: null
      });
    }
  }
  render() {
    const {
      data,
      range
    } = this.state;
    if (data === null) return null;
    const prev = data && data.previous || {};
    const cells = [["activeContacts", "Active contacts"], ["sessions", "Visits"], ["pageViews", "Page views"], ["productsViewed", "Products viewed"], ["conversions", "Conversions"], ["engagements", "Engagements"]];
    // Same ribbon as Content Hub Overview, Email and Website Analytics (analytics-kit Ribbon).
    const tiles = cells.map(([k, l]) => ({
      l,
      v: data ? num(data[k]) : "…",
      d: data ? change(data[k], prev[k], range) : null,
      s: k === "activeContacts" && data && Number(data.newContacts) > 0 ? `${num(data.newContacts)} new` : ""
    }));
    return /*#__PURE__*/React.createElement("div", {
      className: "pc-ribbon"
    }, /*#__PURE__*/React.createElement(Ribbon, {
      tiles: tiles,
      comparing: data ? true : undefined,
      cols: tiles.length,
      loading: data === undefined,
      note: `${rangeLabelFor(range, RANGES)}. A change shows when both periods have at least ${MIN}.`
    }));
  }
}